import React from 'react';
import { Container } from 'components/UI';
import IntroDefault from './IntroDefault';
import { getMeetupDateString } from 'utils';
import { meetupTime } from 'define';

import * as styles from './Intro.module.scss';

export default function Intro({ customDate, showDefaultIntro, ...props }) {
  const componentProps = {
    ...props,
    date: customDate ?? getMeetupDateString(),
    time: meetupTime,
  };

  return (
    <Container className={styles.container} background="transparent">
      <IntroDefault {...componentProps} />
    </Container>
  );
}
